export const formatPermissions = (
  permissions: { id: any; name: any; resource: any }[],
  isGlobal: boolean,
): any[] => {
  let abilities = [
    {
      action: "manage",
      subject: "all",
    },
  ];
  if (!isGlobal) {
    abilities = permissions?.map((p: { name: any; resource: any }) => ({
      action: p.name,
      subject: p.resource,
    }));
    abilities.push({
      action: "view",
      subject: "dashboard",
    });
  }
  return abilities;
};
